import Chart from "chart.js";
// Parse global options
export function parseOptions(parent, options) {
  for (let item in options) {
    if (typeof options[item] !== 'object') {
      parent[item] = options[item];
    } else {
      parseOptions(parent[item], options[item]);
    }
  }
}

function chartOptions() {
  // Options
  let options = {
    defaults: {
      global: {
        pointHitRadius: 5,
        maintainAspectRatio: false,
        responsive: true,
      }
    }
  };

  // yAxes
  Chart.scaleService.updateScaleDefaults('linear', {
    gridLines: {
      borderDash: [15, 10],
      tickMarkLength: 1,
      lineWidth: 1,
      zeroLineWidth: 2,
    },
    ticks: {
      padding: 20,
      fontSize: 10,
      stepSize: 0,
      min: 0,
    }
  });

  // xAxes
  Chart.scaleService.updateScaleDefaults('category', {
    gridLines: {
      drawBorder: false,
      zeroLineColor: 'transparent',
    },
    ticks: {
      padding: 15,
      fontSize: 10,
    },
  });

  return options;
}

let initialized = false
export function initGlobalOptions() {
  if (initialized){
    return
  }
  parseOptions(Chart, chartOptions());
  initialized = true
}
